export class ColorUtils {
  static isColorHex(color: string): boolean {
    return color.startsWith("#")
  }

  static hexToRGB(hex: string, alpha: number): string {
    let r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);

    if (alpha) {
      return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    } else {
      return "rgb(" + r + ", " + g + ", " + b + ")";
    }
  }


  static setAlphaOnRGB(rgb: string, alpha: number): string {
    if(ColorUtils.isColorHex(rgb)) return ColorUtils.hexToRGB(rgb, alpha)
    let match = rgb.replace(/\s/g, '').match(/\((.*)\)/);
    if(match) {
      let [r, g, b, a] = match[1].split(',').map(Number);
      return a !== undefined ? `rgba(${r}, ${g}, ${b}, ${alpha})` : `rgba(${r}, ${g}, ${b}, ${alpha})`;
    } else {
      console.error('No match found! Returning black color. ColorUtils Params: -RGB: ', rgb, '-Alpha: ', alpha);
      return "rgba(0, 0, 0, 1)"
    }

  }


  static rgbToHex(rgb: string): string {
    let rgbArray = rgb.replace("rgb", "").replace("a","").replace("(", "").replace(")", "").split(",")
    let r = parseInt(rgbArray[0])
    let g = parseInt(rgbArray[1])
    let b = parseInt(rgbArray[2])
    return "#" + ColorUtils.parseToTwoDigitHex(r) + ColorUtils.parseToTwoDigitHex(g) + ColorUtils.parseToTwoDigitHex(b)
  }

  static parseToTwoDigitHex(c: number): string {
    let hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }
}
